import pt from './Files/ptBR';

const Translations = {
  pt,
};

export default Translations;
